/**
 * Persist org logo from login / branding for portal sidebars.
 * Accepts absolute URLs and relative portal-logos / public-assets keys.
 */
export function applyLoginOrgLogo(persistOrgLogoFn, orgLogo) {
  if (typeof persistOrgLogoFn !== "function") return null;
  const raw = orgLogo == null ? "" : String(orgLogo).trim();
  if (!raw) {
    persistOrgLogoFn(null);
    return null;
  }
  return persistOrgLogoFn(raw);
}
